import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6.037 12.404a.639.639 0 00.934 0l7.493-7.493a.666.666 0 000-.947l-.707-.707a.666.666 0 00-.933 0l-6.32 6.32-2-1.986a.64.64 0 00-.933 0l-.707.706a.667.667 0 000 .947l3.173 3.16z" fill="#fff" /></svg>);